import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { Category } from 'types/category';
import { OffsetPaginated, OffsetPaginationParams } from 'types/pagination';

import { useAPI } from './useAPI';
import { useAuthenticatedQuery } from './useAuthenticatedQuery';

export type UseCategoriesParams = {
  only_highlighted?: boolean;
  only_non_highlighted?: boolean;
  labels?: string[];
};

type UseCategoriesOptions = UseQueryOptions<
  OffsetPaginated<Category>,
  APIError
> & { params?: UseCategoriesParams & OffsetPaginationParams };

export function useCategories({
  queryKey = ['categories'],
  params,
  ...options
}: UseCategoriesOptions = {}) {
  const { client } = useAPI();
  const queryParams = {
    pagination: 'offset',
    page: 1,
    limit: 50,
    ...params,
  };

  return useAuthenticatedQuery(
    [...queryKey, queryParams],
    async () => {
      const { data } = await client.get(`/categories`, { params: queryParams });

      return data;
    },
    options
  );
}
